import React, { useEffect, useState } from "react";
import { Rnd } from "react-rnd";
import { currentUser } from "store/users/reducers";

const ResizeAndDraggable = ({
  defaultValue = {
    x: 150,
    y: 205,
    width: 270,
    height: 323,
  },
  minWidth = 270,
  minHeight = 323,
  children,
  aspectRatio = true,
  resize = (data) => data,
  resizeEnd,
  bounds = "window",
  onFocusValue = false,
  showAccordin,
  setDirectionResizing,
  page,
  center = true,
  collapsedHeight = 48,
  ...props
}) => {
  const [dimensions, setDimensions] = useState({
    width: defaultValue?.width,
    height: defaultValue?.height,
  });
  const [minHeightChecker, setMinCheck] = useState(false);
  const [isResizing, setIsResizing] = useState(false);
  const { x, y, ...others } = defaultValue;

  useEffect(() => {
    resize({ width: defaultValue.width, height: defaultValue.height });
  }, []);

  const resizeHandleStyles = {
    top: { display: "ew-resize" },
    bottom: { display: "ew-resize" },
    left: { cursor: "ew-resize" },
    right: { cursor: "ew-resize" },
    topLeft: { cursor: "nwse-resize" },
    topRight: { cursor: "nesw-resize" },
    bottomLeft: { cursor: "nesw-resize" },
    bottomRight: { cursor: "nwse-resize" },
  };

  const getInitialPosition = () => {
    const widgetWidth = defaultValue?.width || dimensions.width;
    const widgetHeight = defaultValue?.height || dimensions.height;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    if (center) {
      let x = Math.max(0, Math.floor((window.innerWidth - widgetWidth) / 2));
      let y = Math.max(0, Math.floor((window.innerHeight - widgetHeight) / 2));
      if (page === "wheel") {
        y = y + 50;
      }
      else if (page === "noise_meter") {
        x = windowWidth > 1800 ? x - 600 : windowWidth < 1200 ? x - 200 : x - 400;
        y = y - 100;
      }
      else {
        y = y - 100;
      }
      return { x, y };
    }
    if (defaultValue?.x !== undefined && defaultValue?.y !== undefined) {
      return { x: defaultValue.x, y: defaultValue.y };
    }
    const x = Math.floor((windowWidth - widgetWidth) / 2);
    const y = Math.floor((windowHeight - widgetHeight) / 2);
    return { x, y };
  };

  const initialPosition = getInitialPosition();

  const minHeightForSpecificPage = 44;

  useEffect(() => {
    const checkMinHeight = () => {
      if (showAccordin !== undefined && !showAccordin) {
        if (page === "station" || page === "text" || page === "group") {
          setMinCheck(Math.max(minHeightForSpecificPage, collapsedHeight));
          return;
        }
        setMinCheck(collapsedHeight);
        return;
      } else {
        setMinCheck(minHeight);
      }
    };
    checkMinHeight();
  }, [collapsedHeight, minHeight, page, showAccordin]);

  useEffect(() => {
    if (isResizing) {
      document.body.classList.add("isDragging");
    } else {
      document.body.classList.remove("isDragging");
    }
  }, [isResizing]);

  return (
    <Rnd
      // style={{ zIndex: 99999999 }}
      lockAspectRatio={aspectRatio}
      default={{
        x: initialPosition.x,
        y: initialPosition.y,
        ...others,
      }}
      size={{
        height: !showAccordin ? collapsedHeight : dimensions?.height,
        width: dimensions?.width,
      }}
      allowAnyClick={false}
      minWidth={minWidth}
      minHeight={minHeightChecker}
      bounds={bounds}
      disableDragging={false}
      enableResizing={showAccordin}
      resizeHandleStyles={aspectRatio ? resizeHandleStyles : {}}
      cancel={"input,textarea,select,option,button,.ant-tabs,.data-no-drag,.no-drag,.prevFeedBackWdgt,.widgetFooter,[role='tablist'],[role='tab'][contenteditable='true']"}
      onResize={(e, direction, ref, delta, position) => {
        if (page === "clock") {
          if (
            direction === "topLeft" ||
            direction === "topRight" ||
            direction === "bottomLeft" ||
            direction === "bottomRight"
          ) {
            setDirectionResizing(true);
          } else {
            setDirectionResizing(false);
          }
        }
        const rawW = parseInt(ref.style.width, 10);
        const rawH = parseInt(ref.style.height, 10);
        if (!Number.isFinite(rawW) || !Number.isFinite(rawH) || rawW < 1 || rawH < 1) {
          return;
        }
        const layout = {
          width: rawW,
          height: rawH,
          transform: `${Math.min(3, rawW / minWidth, rawH / minHeight)}`,
        };
        setDimensions(layout);
        resize(layout);
      }}
      onResizeStart={() => setIsResizing(true)}
      onResizeStop={() => setIsResizing(false)}
      {...props}
    >
      <div style={{ width: "100%", height: "100%" }}>
        {children}
      </div>
    </Rnd>
  );
};

export default React.memo(ResizeAndDraggable);
